import React, { useState } from "react";
import {
  Feature4ContainerBox,
  SubtitleText,
  Feature4SmallBox,
  SmallTitle,
  TitleText,
  TitleHolder,
  IconGroup,
  Paypal,
  Bitcoin,
  CashApp,
  Zelle,
  Bank,
  Venmo,
} from "./Feature4.styles";
import { SubtitleHolder } from "../Feature3/Feature3.styles";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLocale } from "../../../../locales/localeSlice";

const Features4 = () => {
  const [isHovered, setIsHovered] = useState(false);
  const { t } = useTranslation();
  const currentLocale = useSelector(selectLocale);
  const handleHover = () => {
    setIsHovered(true);
  };

  const handleLeave = () => {
    setIsHovered(false);
  };
  return (
    <>
      <Feature4ContainerBox
        isHovered={isHovered}
        onMouseEnter={handleHover}
        onMouseLeave={handleLeave}
      >
        <TitleHolder>
          <TitleText
            isHovered={isHovered}
            onMouseEnter={handleHover}
            onMouseLeave={handleLeave}
          >
            {t("amazingFeatures.cardThree.titleText1", {
              lng: currentLocale,
            })}
            <br />
            {t("amazingFeatures.cardThree.titleText2", {
              lng: currentLocale,
            })}
          </TitleText>
        </TitleHolder>
        <SubtitleHolder>
          <SubtitleText
            isHovered={isHovered}
            onMouseEnter={handleHover}
            onMouseLeave={handleLeave}
          >
            {t("amazingFeatures.cardOne.subTextLineOne", {
              lng: currentLocale,
            })}
            {t("amazingFeatures.cardOne.subTextLineTwo", {
              lng: currentLocale,
            })}
          </SubtitleText>
        </SubtitleHolder>
        <Feature4SmallBox
          isHovered={isHovered}
          onMouseEnter={handleHover}
          onMouseLeave={handleLeave}
        >
          <SmallTitle
            isHovered={isHovered}
            onMouseEnter={handleHover}
            onMouseLeave={handleLeave}
          >
            {t("amazingFeatures.cardThree.smallBox.title", {
              lng: currentLocale,
            })}
          </SmallTitle>
          <IconGroup>
            <Paypal src="/assets/icons/paypal.png" />
            <CashApp src="/assets/icons/cash-app.png" />
            <Zelle src="/assets/icons/zelle.png" />
          </IconGroup>
          <IconGroup>
            <Bitcoin src="/assets/icons/bitcoin.png" />
            <Bank src="/assets/icons/bank.png" />
            <Venmo src="/assets/icons/216780_venmo_icon.png" />
          </IconGroup>
        </Feature4SmallBox>
      </Feature4ContainerBox>
    </>
  );
};

export default Features4;
